// R13 Workstream 7 - one view-model for a refused stage move, built from the backend's structured
// refusal (stage_rejection.enrich). Customer 360, the Pipeline table, the Kanban board and the Process
// Case stage rail all render THIS, so a record that "didn't move" always says why and what to do.

// Blocker types that already open a purpose-built workflow dialog (call outcome, consultation outcome,
// admission outcome, backward-move reason, workflow setup, Case outcome form). Everything else is
// explained by the shared dialog instead of a toast that disappears.
export const DEDICATED_BLOCKERS = new Set([
  "required_call_outcome", "required_consultation_outcome", "required_admission_outcome",
  "backward_reason_required", "reversal_reason_required", "workflow_setup_required", "outcome_required",
]);

export const gateView = (error, ctx = {}) => {
  const status = error?.response?.status ?? null;
  const d = error?.response?.data?.detail;
  const obj = d && typeof d === "object" ? d : {};
  const message = typeof d === "string" ? d : (obj.message || error?.message || "The move was refused.");
  const tasks = (obj.missing?.tasks && obj.missing.tasks.length)
    ? obj.missing.tasks : (obj.unmet_tasks || []).map((t) => t.title).filter(Boolean);
  return {
    status,
    blockerType: obj.blocker_type || obj.code || null,
    requested: ctx.requested || null,
    current: ctx.current || null,
    subject: ctx.subject || null,
    message,
    invariant: obj.blocking_invariant || null,
    missingTasks: tasks,
    missingItems: obj.missing?.items || [],
    missingKind: obj.missing?.kind || null,
    nextAction: obj.next_action || null,
    // A refusal with no structured body (network error, 5xx) can be retried; a structured refusal says so.
    retryAllowed: typeof obj.retry_allowed === "boolean" ? obj.retry_allowed : status == null || status >= 500,
    overridable: obj.overridable === true,
    existingCaseId: obj.existing_case_id || null,
    permitted: obj.permitted || null,
  };
};

// What the dialog says about retrying, in words.
export const retryText = (v) => {
  if (v.overridable) return "A user with override permission can clear this with a written reason.";
  if (v.retryAllowed) return "Do the step above, then try the move again.";
  return "This cannot be overridden or retried as it stands.";
};

// A refusal the page itself makes before calling the server (for example "this card has not entered
// Process yet") uses the same view, so the user sees the same dialog either way.
export const clientGateView = ({ subject, current, requested, message, nextAction, retryAllowed = true }) => ({
  status: null, blockerType: "client_precheck", requested: requested || null, current: current || null,
  subject: subject || null, message, invariant: null, missingTasks: [], missingItems: [], missingKind: null,
  nextAction: nextAction || null, retryAllowed, overridable: false, existingCaseId: null, permitted: null,
});
